import OverflowMenuVertical32 from '@carbon/icons-react/es/overflow-menu--vertical/32';
import { Menu as AntMenu } from 'antd';
import styled from 'styled-components';

export const Menu = styled(AntMenu)`
  background: var(--coolest-gray-10);
  border: 0px;
  padding: 0px;
  && .ant-menu-item {
    padding: var(--spacing-03) var(--spacing-05) var(--spacing-03) 0;
    margin-left: 1px;
    width: 160px;
  }
`;

export const ExpandedIcon = styled(OverflowMenuVertical32)`
  padding-top: var(--spacing-04);
  padding-bottom: var(--spacing-02);
`;

export const CompactExpandMenu = styled(Menu.SubMenu)`
  height: auto;
  width: auto;
  white-space: break-spaces;
  border: none;
  &&.ant-menu-submenu.ant-menu-submenu-horizontal {
    border-bottom: none;
    width: auto;
    min-width: 0px;
    padding: var(--spacing-04) var(--spacing-03) var(--spacing-02)
      var(--spacing-03);
  }
`;
